import 'swiper/swiper-bundle.css';
import { Box, Grid2, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { materialStyles } from './styles';
import { Icon } from '../Icon';
import { getTomorrowDate } from '../../helpers';
import { useTimer } from '../../hooks/useTimer';
import { useTranslation } from 'react-i18next';

interface IAttemptsWidget {
  isTraining?: boolean;
  attempts?: number;
  totalAttempts?: number;
}

const AttemptsWidget: React.FC<IAttemptsWidget> = ({
  isTraining,
  attempts,
  totalAttempts,
}) => {
  const { t } = useTranslation();
  const targetTime = useMemo(() => getTomorrowDate(), []);
  const timer = useTimer(targetTime, undefined, 'SHORT_TIME');
  return (
    <Grid2 sx={materialStyles.container}>
      {!isTraining && timer && (
        <Box sx={materialStyles.timerContainer}>
          <Typography sx={materialStyles.timerText}>{timer}</Typography>
        </Box>
      )}

      <Icon sx={materialStyles.attemptsIcon} iconName="AttemptsIcon" />
      {isTraining ? (
        <Typography sx={materialStyles.trainingAttemptsText}>
          {t('game.unlimited')}
        </Typography>
      ) : (
        <Typography sx={materialStyles.attemptsText}>
          {attempts} {'/'} {totalAttempts}
        </Typography>
      )}
    </Grid2>
  );
};

export default AttemptsWidget;
